import EmailVerificationPage from './EmailVerificationPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const EmailVerificationPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/email/verify',
      component: EmailVerificationPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/login/EmailVerificationPageConfig.js